import { useContext } from 'react';
import { ContextApp } from '../../../../contexts/ContextApp';

interface Props {
  sender: string | undefined;
  receiptnumber: string | undefined;
  amount: number | null | undefined;
  currency: string | undefined;
}

const CurrentReceiptInformation = ({
  sender,
  receiptnumber,
  amount,
  currency,
}: Props) => {
  const { t } = useContext(ContextApp);
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#EFF9FF',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        marginBottom: '18px',
      }}
    >
      <div style={{ display: 'flex', gap: 8 }}>
        <span>{t('entity.senderName')}:</span>
        <span style={{ fontWeight: 700 }}>{sender}</span>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <span>{t('field.invoiceReceiptNumber')}:</span>
        <span style={{ fontWeight: 700 }}>{receiptnumber}</span>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <span>{t('field.invoiceReceiptTotal')}:</span>
        <span style={{ fontWeight: 700 }}>
          {currency} {amount}
        </span>
      </div>
    </div>
  );
};

export default CurrentReceiptInformation;
